import { render, staticRenderFns } from "./DivideOrder.vue?vue&type=template&id=8349c08e&scoped=true"
import script from "./DivideOrder.vue?vue&type=script&lang=js"
export * from "./DivideOrder.vue?vue&type=script&lang=js"
import style0 from "./DivideOrder.vue?vue&type=style&index=0&id=8349c08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8349c08e",
  null
  
)

export default component.exports